/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I convert probability to Q?`)
};

const es_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo convierto probabilidad a Q?`)
};

const de_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie rechne ich Wahrscheinlichkeit in Q um?`)
};

const nl_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe zet ik kans om naar Q?`)
};

const fr_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment convertir une probabilité en Q ?`)
};

const it_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come converto la probabilità in Q?`)
};

const pt_br2_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como converto probabilidade em Q?`)
};

const pt_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como converto a probabilidade em Q?`)
};

const ja_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確率をQに変換するには？`)
};

const zh_phred_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何将概率转换为 Q？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_faq_q4", locale)
	if (locale === "en") return en_phred_faq_q4(inputs)
	if (locale === "es") return es_phred_faq_q4(inputs)
	if (locale === "de") return de_phred_faq_q4(inputs)
	if (locale === "nl") return nl_phred_faq_q4(inputs)
	if (locale === "fr") return fr_phred_faq_q4(inputs)
	if (locale === "it") return it_phred_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_phred_faq_q4(inputs)
	if (locale === "pt") return pt_phred_faq_q4(inputs)
	if (locale === "ja") return ja_phred_faq_q4(inputs)
	return zh_phred_faq_q4(inputs)
};